import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import { injectIntl } from 'react-intl';
import EventsPageComponent from '@fuww/library/src/Layouts/EventsPage';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import messages from '../lib/messages.mjs';
import Head from '../components/Head';
import HomeLink from '../components/HomeLink';
import Events from '../components/Events';
import EventPage from '../lib/eventPage';
import LinkAndAnchor from '../components/LinkAndAnchor';
import withApollo from '../lib/apollo';
import getCurrentDate from '../lib/getCurrentDate';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/S-ZCYXvOFlPfp1CyzZkznQQV-5E1O9cxlex5vofFz4M/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS90cmFkZXNob3ctaGVhZGVyLmpwZw',
    'https://r.fashionunited.com/rm9uVetgpLTMfYWcl5pS66bgpTTAtFnNbmkwxrl4zPM/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS90cmFkZXNob3ctaGVhZGVyLmpwZw',
    'https://r.fashionunited.com/s6qnA4TVEMcuW1PBeJdGmygmfGUvs3x-yx1O1zat3Qw/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS90cmFkZXNob3ctaGVhZGVyLmpwZw',
  ],
  desktop: [
    'https://r.fashionunited.com/ybKHZFEHTwJA5WqWiWcyDzh1p9oHQXqK1a_JgolpKlc/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS90cmFkZXNob3ctaGVhZGVyLmpwZw',
    'https://r.fashionunited.com/Epmf2wLos5MU0HyE-D8x1q79wg38uRPTR-4cnmlzrFo/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS90cmFkZXNob3ctaGVhZGVyLmpwZw',
    'https://r.fashionunited.com/nP5ZMaTAgdAj6fDXgMG9IS7T5XhVvhVxlGBLbbN1Nw4/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS90cmFkZXNob3ctaGVhZGVyLmpwZw',
    'https://r.fashionunited.com/Pjljnb4qQFUWHsakhHnutzNLLwJFaTS6Yt5WGTmxeFQ/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS90cmFkZXNob3ctaGVhZGVyLmpwZw',
  ],
};
class EventsPage extends EventPage {
  static async getInitialProps({ req, res, ...rest }) {
    const properties = await EventPage.getInitialProps({ req, res, ...rest });

    return { ...properties, now: getCurrentDate().toString() };
  }

  render() {
    const {
      intl,
      now,
    } = this.props;

    const breadcrumbs = [
      <HomeLink />,
      <LinkAndAnchor
        route="events"
        passHref
      >
        {intl.formatMessage(messages.events)}
      </LinkAndAnchor>,
    ];

    return (
      <EventsPageComponent
        breadcrumbs={breadcrumbs}
        title={intl.formatMessage(messages.eventsTitle)}
        description={intl.formatMessage(messages.eventsIntro)}
      >
        <Head
          title={intl.formatMessage(messages.eventsTitle)}
          description={intl
            .formatMessage(messages.eventsMetaDescription)}
        />
        <Events now={now} />
      </EventsPageComponent>
    );
  }
}

EventsPage.propTypes = {
  router: PropTypes.shape({}),
  intl: PropTypes.shape({ formatMessage: PropTypes.func }).isRequired,
};

EventsPage.defaultProps = {
  router: {},
};

export const EventsWithoutApollo = withRouter(injectIntl(EventsPage));

EventsWithoutApollo.getLayout = (page) => (
  <Layout
    header={(
      <Hero
        imageUrls={headerImageUrls}
        alt="FashionUnited Events"
      />
  )}
  >
    {page}
  </Layout>
);

export default withApollo(EventsWithoutApollo);
